import { FilterUsers } from 'src/models/filter';

import { Callback } from 'src/util/query/models/Callback';

import { NoteListCallbackStoreContract } from '../interfaces';

export class GetAllUsersWithAccessToTheModuleForTheUserFilterNoteListCallBack extends Callback<Array<FilterUsers>> {
	public constructor(private readonly store: NoteListCallbackStoreContract) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<FilterUsers>): void => {
		this.store.setFilterUsers(successResponse);
	};
}
